'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _axios3 = require('./axios.jsonp');

var _axios4 = _interopRequireDefault(_axios3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _class = function () {
    function _class(url) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        _classCallCheck(this, _class);

        this.url = url;
        this.options = options;

        return this;
    }

    _createClass(_class, [{
        key: 'send',
        value: function send(data) {
            return this._send('post', data, this.options);
        }
    }, {
        key: 'post',
        value: function post(data) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.options;

            return this._send('post', data, options);
        }
    }, {
        key: 'put',
        value: function put(data) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.options;

            return this._send('put', data, options);
        }
    }, {
        key: 'delete',
        value: function _delete(data) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.options;

            return this._delete('delete', options);
        }
    }, {
        key: 'get',
        value: function get() {
            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.options;

            if (options.data && _typeof(options.data) === 'object') {
                // для отправки данных в URLSearchParams, их нужно отправлять через params
                options.params = Object.assign({}, options.data, options.params || {});
            }

            if (options.dataType === 'jsonp') {
                return (0, _axios2.default)(Object.assign({
                    url: this.url
                }, options, this._getCancelToken(), {
                    adapter: _axios4.default
                }));
            } else {
                return _axios2.default.get(this.url, Object.assign({}, options, this._getCancelToken()));
            }
        }
    }, {
        key: '_delete',
        value: function _delete() {
            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            var config = Object.assign({}, options, this._getCancelToken());

            return _axios2.default.delete(this.url, config);
        }
    }, {
        key: '_send',
        value: function _send() {
            var method = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'get';
            var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            var config = Object.assign({}, options, this._getCancelToken());

            delete config.data;
            return _axios2.default[method](this.url, data, config);
        }
    }, {
        key: '_getCancelToken',
        value: function _getCancelToken() {
            var CancelToken = _axios2.default.CancelToken;

            this._cancelSource = CancelToken.source();
            return { cancelToken: this._cancelSource.token };
        }
    }, {
        key: 'close',
        value: function close() {
            return this._cancelSource && this._cancelSource.cancel();
        }
    }]);

    return _class;
}();

exports.default = _class;